import { get } from 'lodash';
import { ROW_TYPES } from 'workflow/constants/newInbox';

const EventRowConfigs = [{
    label: 'Sent From',
    field: 'sentFrom'
}, {
    label: 'Sent By',
    field: 'createdBy.displayName'
}, {
    label: 'Sent Date',
    field: 'sentDate',
    type: ROW_TYPES.DATETIME
}];

const EventRowConfigsV4 = [{
    label: 'Binder',
    field: 'sentFrom',
    type: ROW_TYPES.LINK
}, {
    label: 'Sent By',
    field: 'createdBy.displayName'
}, {
    label: 'Sent Date',
    field: 'sentDate',
    type: ROW_TYPES.DATETIME
}];

const StatementOfTestament = {
    label: 'Statement of Testament',
    value: 'I approve the details of this Event'
};

const MonitorVisitFields = [
    {
        label: 'Type',
        field: 'event.eventType'
    },
    {
        label: 'Date Of Visit',
        field: 'event.dateOfVisit',
        type: ROW_TYPES.DATE_NO_TZ
    },
    {
        label: 'Visit Type',
        field: 'event.monitorVisitType'
    },
    {
        label: 'Monitor',
        field: 'event.monitor.displayName'
    }
];

const ICFFields = [
    {
        label: 'Type',
        field: 'event.eventType'
    },
    {
        label: 'IRB Approval Date',
        field: 'event.irbApprovalDate',
        type: ROW_TYPES.DATE_NO_TZ
    },
    {
        label: 'ICF Type',
        field: 'event.icfType'
    },
    {
        label: 'ICF Language',
        field: 'event.icfLanguage'
    },
    {
        label: 'Reconsent Required',
        field: 'event.reconsentRequired'
    },
    {
        label: 'Sponsor Version',
        field: 'event.sponsorVersion'
    },
    {
        label: 'Site Version',
        field: 'event.siteVersion'
    },
    {
        label: 'Protocol Version',
        field: 'event.protocolVersion'
    },
    {
        label: 'Summary of Changes',
        field: 'event.summaryOfChanges'
    }
];

export const EVENT_TYPE = {
    MONITOR_VISIT: {
        displayName: 'Monitor Visit',
        fields: [...EventRowConfigs, ...MonitorVisitFields, StatementOfTestament]
    },
    ICF: {
        displayName: 'ICF Version Change',
        fields: [...EventRowConfigs, ...ICFFields, StatementOfTestament]
    }
};

export const EVENT_TYPEV4 = {
    MONITOR_VISIT: {
        displayName: 'Monitor Visit',
        fields: [...EventRowConfigsV4, ...MonitorVisitFields, StatementOfTestament]
    },
    ICF: {
        displayName: 'ICF Version Change',
        fields: [...EventRowConfigsV4, ...ICFFields, StatementOfTestament]
    }
};
const ViewAcceptRender = ['DatePicker', 'SingleSelect', 'User', 'ShortText'];

export const getFieldsOfCustomEvent = (detailData, isNewV4) => {
    const EventType = {
        label: 'Type',
        field: 'customEvent.eventType.displayName'
    };

    const fields = get(detailData, 'customEvent.fields', []);

    const fieldMaps = fields
        .filter(({ view }) => ViewAcceptRender.some(v => v === view))
        .map(({ displayName, value, valueType }) => ({
            label: displayName,
            value: value || null,
            type: valueType === 'Date' ? ROW_TYPES.DATE_NO_TZ : null
        }));

    return [...(isNewV4 ? EventRowConfigsV4 : EventRowConfigs), EventType, ...fieldMaps, StatementOfTestament];
};
